
import Typography from '@/ui-kit/components/typography';
import { TypographyType, TypographyProperty } from '@/ui-kit/components/typography/enums';
import SummaryChart from '@/components/page-specific/market-data/summary-chart';

const COMMUNITY_DEFAULT_VALUE = 'None';
const PRICE_DELTA = 2000000;

export default {
  name: 'ListingSoldTrendsChart',
  components: {
    Typography,
    SummaryChart,
  },
  props: {
    listing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      TypographyType,
      TypographyProperty,
    };
  },
  computed: {
    location() {
      return (this.listing.community !== COMMUNITY_DEFAULT_VALUE && this.listing.community)
        || this.listing.city;
    },
    soldChartParams() {
      return {
        city: this.listing.city,
        community: [this.listing.community],
        transactionDate: '1 year',
        maxPrice: this.listing.price + PRICE_DELTA,
        minPrice: 0,
        province: this.listing.province,
      };
    },
  },
};
